export async function copyText(text: string): Promise<boolean> {
  try { if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(text); return true; } } catch { /* Fall back for HTTP and denied clipboard permissions. */ }
  const previous = document.activeElement;
  const area = document.createElement('textarea'); area.value = text; area.readOnly = true;
  Object.assign(area.style, { position: 'fixed', left: '0', top: '0', opacity: '0', width: '1px', height: '1px' });
  document.body.appendChild(area);
  try { area.focus(); area.select(); area.setSelectionRange(0, text.length); return document.execCommand('copy'); }
  catch { return false; }
  finally { area.remove(); if (previous instanceof HTMLElement) previous.focus(); }
}
